import { Nullable } from '@clearverify/types';

import { EmployeeWhere, InboxItemsListWhere, InboxItemWhere } from 'src/api';

export const prepareInboxSearchFilter = (searchValue: Nullable<string>): InboxItemsListWhere => {
  if (!searchValue) return {};
  return { searchText: searchValue };
};

export const buildInboxItemFilterByEmployee = (
  employeeFilter: EmployeeWhere,
  { skipTestVerificationRequest = false } = {},
): InboxItemWhere => {
  return {
    OR: [
      { verificationRequest: { employee: employeeFilter } },
      { dataDispute: { employee: employeeFilter } },
      {
        testVerificationRequest: skipTestVerificationRequest
          ? { employee: employeeFilter }
          : undefined,
      },
    ],
  };
};

export const prepareInboxSearchFilterOnlyByValue = (searchValue: Nullable<string>) => {
  return prepareInboxSearchFilter(searchValue);
};
